module.exports = __webpack_public_path__ + "static/img/th-crads-crariskprofile-01.9d59748.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnails/th-crads-crariskprofile-01.png
// module id = Og8m
// module chunks = 1